/// <amd-module name="Search/Wiki/WikiUtils" />

import { areFiltersEqual } from "Search/Shared/Utils";
import { WikiSearchRequest } from "Search/WebApi/Contracts/Search.Shared";

export function htmlEncode(str: string): string {

    // we can write a slightly faster (30%) version that uses a regexp to find and replace
    // all occurences of [&<>"] by their corresponding HTML entities but this approach
    // uses the DOM implementation, so presumably it covers all input/edge cases.

    var div = document.createElement("div");
    div.appendChild(document.createTextNode(str));

    // The trick we are using here doesnt encode quotes. So we have to replace them using regexp search
    return div.innerHTML
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

export function areQueriesEqual(left: WikiSearchRequest, right: WikiSearchRequest): boolean {
    if (left.searchText !== right.searchText) {
        return false;
    }

    if (left.$top !== right.$top) {
        return false;
    }

    return areFiltersEqual(left.filters, right.filters);
}

const WHITE_SPACE_REGEX = /(\s+)/g;
const NEW_LINE_REGEX = /[.]*[\s]*(\n+)/g;
const HIT_HIGHT_LIGHT_HTML_ENCODED_START_TAG_REGEX = /(&lt;highlighthit&gt;)/gi;
const HIT_HIGHT_LIGHT_HTML_ENCODED_END_TAG_REGEX = /(&lt;\/highlighthit&gt;)/gi;
const HIGHLIGHTSTARTTAG = "<highlighthit>";
const HIGHLIGHTENDTAG = "</highlighthit>";

export function sanitizeHtml(html: string): string {
    // replace multiple return characters with .
    html = html.replace(NEW_LINE_REGEX, ". ");
    // replace multiple white spaces with a single white space.
    html = html.replace(WHITE_SPACE_REGEX, " ");
    let encodedValue = htmlEncode(html);

    return encodedValue
        .replace(HIT_HIGHT_LIGHT_HTML_ENCODED_START_TAG_REGEX, HIGHLIGHTSTARTTAG)
        .replace(HIT_HIGHT_LIGHT_HTML_ENCODED_END_TAG_REGEX, HIGHLIGHTENDTAG);
}

export namespace UrlEscapeConstants {
    export const HyphenRegExp = /-/g;
    export const HyphenEncoding = "%2D";
    export const Hyphen = "-";
    export const WhiteSpace = " ";
}